<div class="content">
  <img src="../../../../../../assets/images/thank-you.png"/>
  <p> {{'pages.thankYou.thankYouMessage' | translate}}</p>
  <p [innerHTML]="'pages.thankYou.verifyEmailMessage' | translate"> </p>
</div>
